import { Container, Input } from 'components/atoms';
import { t } from 'i18next';
import { PiBank, PiHouseLine, PiWallet } from 'react-icons/pi';
import { useGetLabel } from 'services/labels';
import { CUSTOMER_TYPE } from 'services/labels/types';
import { useGetCountries } from 'services/enums';
import { AddressForm } from 'components/molecules';
import ViewHint from 'components/molecules/hint/ViewHint';

const LabelBanking = () => {
  const { data: label } = useGetLabel(false);
  const countries = useGetCountries();

  const getCountryLabel = (code?: string) => {
    if (!code) return '';

    const country = countries.data?.find((c) => c.codeAlfa2 === code);

    return country ? t(`countries.${country.codeAlfa2}`) : code;
  };

  return (
    <>
      <div />
      <ViewHint hintId="label-banking" />

      {label?.customerTypeId === CUSTOMER_TYPE.Physical ? (
        <>
          <Input.Text
            name={'personalIdCountryAlfa2'}
            label={t('input.label.country')}
            value={getCountryLabel(label.personalIdCountry)}
            readOnly
          />
          <Input.Text
            name="personalId"
            label={t('input.label.personalId')}
            value={label.personalId}
            readOnly
          />
        </>
      ) : (
        <>
          <Input.Text
            name={'companyCountryAlfa2'}
            label={t('input.label.country')}
            value={getCountryLabel(label?.companyIdCountry ?? '')}
            readOnly
          />
          <Input.Text
            name="companyId"
            label={t('input.label.companyId')}
            value={label?.companyIdCompanyIdentification ?? ''}
            readOnly
          />
        </>
      )}
      <Input.Text
        name="bankAccountNumber"
        label={t('input.label.bankAccountNumber')}
        value={label?.accountDetailsBankAccountNumber}
        readOnly
      />
      <Input.Text
        name="bankName"
        label={t('input.label.bankName')}
        value={label?.accountDetailsBankName}
        readOnly
      />
      <Input.Text
        name="swift"
        label={t('input.label.swift')}
        value={label?.accountDetailsSwift}
        readOnly
      />
    </>
  );
};

export default LabelBanking;
